import React, {Fragment } from 'react';
import { NavLink } from 'react-router-dom';
function NavBarItem(props) {
    let user = JSON.parse(localStorage.getItem('user'));
    let isValid = props.role.includes(user.role);
    return (
        <Fragment>
            {isValid?
                <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink"
                       data-toggle="dropdown">
                        {user.name}
                    </a>
                    <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                        <NavLink className="dropdown-item" to="/updatepassword">Update Password</NavLink>
                        <NavLink className="dropdown-item" to="/logout">Log Out</NavLink>
                    </div>
                </li>

            : <Fragment></Fragment>}
        </Fragment>
    )
}


export default NavBarItem;


// WEBPACK FOOTER //
// ./src/common/NavBarDropDownItem.jsx